import React from "react";
import PropTypes from "prop-types";
import App from "components/App";
import EYTopNavBar from "components/EYTopNavBar";
import RFEClearbanner from "../../../components/EYTopNavBar/assets/RFE2-clear-banner.jpg";
import RFEBox from "../../../components/EYTopNavBar/assets/EY_block.png";
import RFEBoxBackground from "../../../components/EYTopNavBar/assets/EY_block_bg.png";
import { FormattedMessage } from "react-intl";
import "./styles.scss";
import { APP_TITLE } from "../../../constants";

class SignSubmittedCompleted extends App {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        actionKey: PropTypes.string
      })
    })
  };

  SetBackgroundImage = path => {
    return { backgroundImage: "url(" + path + ")" };
  };

  SetBoxLogoStyle = () => {
    return {
      background:
        "url(" +
        RFEBox +
        ") no-repeat, url(" +
        RFEBoxBackground +
        ") 5px 10px no-repeat"
    };
  };

  render() {
    return (
      <React.Fragment>
        <EYTopNavBar displayUser={true} />
        <div className="container">
          <div
            className="RFE-bg__img"
            style={this.SetBackgroundImage(RFEClearbanner)}
          >
            <div className="RFE-img--yellow">
              <div id="top-panel-rfe" />
              <div id="panel-rfe">
                <p className="yellowBoxTitle">
                  <FormattedMessage id={"AuthorizeLink.index.title"} />
                  {` ${APP_TITLE}`}
                </p>
                <p className="yellow-box__subtitle is-7">
                  <FormattedMessage id={"AuthorizeLink.index.shortdesc"} />
                </p>
              </div>
            </div>
          </div>
          <div className="project-deleted__mainText">
            <p>
              <FormattedMessage
                id={"AuthorizeLink.components.confirmation.completed"}
              />
            </p>
          </div>
        </div>
        <div className="bottom-desc">
          <FormattedMessage id={"AuthorizeLink.index.bottomdesc"} />
        </div>
      </React.Fragment>
    );
  }
}
export default SignSubmittedCompleted;
